import { z } from "zod";
import { IdSchema } from "./primitives.js";
export const WalkInPatientSearchQuerySchema = z.object({
    siteId: IdSchema,
    query: z
        .string()
        .trim()
        .max(120)
        .refine((value) => value.replace(/[^\p{L}\p{N}]/gu, "").length >= 4, "Enter at least four letters or numbers"),
    limit: z.coerce.number().int().min(1).max(10).default(10),
});
export const WalkInPatientMatchSchema = z.object({
    patientId: IdSchema,
    displayName: z.string(),
    mrn: z.string(),
    dateOfBirth: z.string().date(),
    administrativeSex: z.enum(["female", "male", "unknown", "other"]),
    phone: z.string().nullable(),
    healthCardLast4: z.string().nullable(),
    lastVisitAt: z.string().nullable(),
});
export const WalkInPatientMatchesSchema = z.array(WalkInPatientMatchSchema).max(10);
//# sourceMappingURL=walk-in-search.js.map